/**
 * Save application data with template.
 *
 * @module storage
 */

'use strict';

module.exports = {
    storageStructureSample: {
        bookmarks: [],
        settings: {
            scale: 100,
            isFullScreen: false,
            isVirtualMouse: false
        }
    },

    /**
     * Prepare storage structure if it's inappropriate.
     *
     * @param {*} data - data from some storage (usually UserFS)
     *
     * @return {Object} ready-to-use data
     */
    prepareStorage: function ( data ) {
        return Object.prototype.toString.call(data).slice(8, -1) === 'Object' ? data : this.storageStructureSample;
    },

    /**
     * Save user data (bookmarks and settings) to UserFS.
     *
     * @param {Object} data - data to store
     *
     * @return {boolean} operation result
     */
    saveData: function ( data ) {
        return core.plugins.ufsJson.saveSync(data);
    }
};
